import {
  ClassAnnotationLabel,
  PolygonAnnotationLabel,
  PolygonOrClassOrKeypointAnnotationLabel,
} from '~redux/types/images';

export function isPolygonLabel(
  labelData: PolygonOrClassOrKeypointAnnotationLabel,
): labelData is PolygonAnnotationLabel {
  return 'coordinates' in labelData && labelData.coordinates !== null;
}

export function isClassificationLabel(
  labelData: PolygonOrClassOrKeypointAnnotationLabel,
): labelData is ClassAnnotationLabel {
  return !('coordinates' in labelData) || labelData.coordinates === null;
}

export function getClassifications(dataObjects?: PolygonOrClassOrKeypointAnnotationLabel[]): string[] | null {
  if (!dataObjects) {
    return null;
  }
  return dataObjects.filter(isClassificationLabel).map((labelData) => labelData.id);
}

export function hasClassifications(dataObjects?: PolygonOrClassOrKeypointAnnotationLabel[]): boolean {
  const classifications = getClassifications(dataObjects);
  return classifications !== null && classifications.length > 0;
}
